import { Title } from '@angular/platform-browser';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Examen } from '@shared/forms/templates/exams-config/Examen.config';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AsideService } from '@shared/components/aside/aside.service';
import { MessageAlertService } from '@shared/views/_messagesService/_messageAlertServices';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { ExamsConfigService } from '@shared/forms/templates/exams-config/exams-config.service';
import { DatabaseService } from '@app/database/database.service';
import moment from 'moment';
import { environment } from '@env/environment';
import { GroupDTemplateService } from '@shared/forms/templates/group-d-template/group-d-template.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { IEspecialidades } from '@app/database/models/IEspecialidades.model';

@Component({
	selector: 'app-group-k-template',
	templateUrl: './group-k-template.component.html',
	styleUrls: ['./group-k-template.component.scss'],
})
export class GroupKTemplateComponent implements OnInit, OnDestroy {
	public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
	@Input() examen: any; // IExamen;
	submitted = false;
	public examForm: FormGroup;
	seniority = 0;
	unidadTiempo = '';
	maxDate = new Date();
	maxDateIngreso = new Date();
	minDate: any;
	asideObservable: Subscription;
	displayAgentes = false;
	baseUrl =
		'https://lasegundatesting.conexia.com.ar:8444/lasegunda-ml-api/exams/carga/';
	configForm: Examen;
	tiposDictamen: any[] = [];
	especialidades: IEspecialidades[];
	invalidField = false;
	attachedFiles: any = {
		data: [],
		invalid: false,
		isEmpty: true,
		attachedFilesValidQuantity: 0
	};
	enviandose = false;
	isOnline = true;
	displayModalFirma = false;
	medicoFirmaB64;
  	medicoFirmaSigString;

	constructor(private router: Router,
		private groupDTemplateService: GroupDTemplateService,
		private titleService: Title,
		private confirmationService: ConfirmationService,
		private asideService: AsideService,
		private messageAlertServices: MessageAlertService,
		private backgroundSyncService: BackgroundSyncService,
		private examConfigService: ExamsConfigService,
		private databaseService: DatabaseService,
		private connectionService: ConnectionService) {
	}

	ngOnInit(): void {
		this.titleService.setTitle('Provincia ART ML Offline');
		this.connectionService.monitor().subscribe((connected: ConnectionState) => {
			this.isOnline = connected.hasNetworkConnection;
		})
		this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
		this.cargarFormulario();
		this.calcularAntiguedad();
		this.getTiposDictamen();
		this.getEspecialidades();
		this.minDate = new Date(moment(this.examen.fechaAsignacion).format());
		this.asideObservable = this.asideService.openModalSubject$.subscribe(
			(data) => {
				this.goBack(data);
			}
		);
		this.asideService.setInsideExamen(true);
	}

	ngOnDestroy(): void {
		if (this.asideObservable) {
			this.asideObservable.unsubscribe();
		}
		this.asideService.setInsideExamen(false);
		this.titleService.setTitle('Provincia ART ML Offline');
	}

	get f(): any {
		return this.examForm.controls;
	}

	cargarFormulario(): void {
		let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
			? this.examen.tipoEstudio.tipoEstudioCod
			: this.examen.tipoEstudio;
		this.configForm = this.examConfigService.getConfig(codigoTipoExamen);
    	this.configForm.name = this.examen.provinciaNombreEstudio;
		this.examForm = this.configForm.examForm;
		this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
		this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
		this.calculateAge();
		this.examen.puestoTrabajador ? this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
		this.examen.antiguedadPuestoTrabajador ? this.examForm.controls.antiguedadPuestoTrabajador.setValue(this.standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
		this.examen.fechaIngresoEmpresa ? this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
		this.restrictDateIngresoEmpresa();
		this.medicoFirmaB64 = this.examen.medicoFirmaB64;
    	this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
		if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {
			this.setValuesOnFormOnVerOrEditMode();
		} else {
			this.examen.antiguedadOtrosCargos = this.examForm.controls.antiguedadOtrosCargos.value;
			this.examen.docente = this.examForm.controls.docente.value;
			this.examen.cargaHorariaOtroEstablecimiento = this.examForm.controls.cargaHorariaOtroEstablecimiento.value;
			this.examen.callCenter = this.examForm.controls.callCenter.value;
			this.examen.otro = this.examForm.controls.otro.value;
			this.examen.monoaural = this.examForm.controls.monoaural.value;
			this.examen.biaural = this.examForm.controls.biaural.value;
			this.examen.reguladorVolumen = this.examForm.controls.reguladorVolumen.value;
			this.examen.tomaAlcohol = this.examForm.controls.tomaAlcohol.value;
			this.examen.tomaMedicacion = this.examForm.controls.tomaMedicacion.value;
			this.examen.fuma = this.examForm.controls.fuma.value;
			this.examen.realizaOtrasActividadesEsfuerzovoz = this.examForm.controls.realizaOtrasActividadesEsfuerzovoz.value;
			this.examen.respiratorios = this.examForm.controls.respiratorios.value;
			this.examen.alergicos = this.examForm.controls.alergicos.value;
			this.examen.quirurgicos = this.examForm.controls.quirurgicos.value;
			this.examen.digestivos = this.examForm.controls.digestivos.value;
			this.examen.herniaHiatal = this.examForm.controls.herniaHiatal.value;
			this.examen.reflujoGastroesofagico = this.examForm.controls.reflujoGastroesofagico.value;
			this.examen.tiroideos = this.examForm.controls.tiroideos.value;
			this.examen.laringitisCronica = this.examForm.controls.laringitisCronica.value;
			this.examen.poliposFaringeos = this.examForm.controls.poliposFaringeos.value;
			this.examen.nodulosVocales = this.examForm.controls.nodulosVocales.value;
			this.examen.disfonia = this.examForm.controls.disfonia.value;
		}
	}

	private calculateAge(): void {
		let edad = null;
		if (this.examForm.controls.fechaNacimiento.value) {
			edad = moment().diff(
			  moment(this.examForm.controls.fechaNacimiento.value),
			  'years'
			);
		}
		this.examen.trabajador.edad = edad;
	}

	restrictDateIngresoEmpresa(): void {
		if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
		  this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
		} else {
		  this.maxDateIngreso = this.maxDate;
		}
	  }

	private getDescripcionSexo(): string {
		if (this.examen.trabajador.sexo) {
			return (this.examen.trabajador.sexo === 'M') ? 'Masculino' : 'Femenino';
		}
		return '';
	}

	standarizeDate(date: any) {
		let splitedDate = date.replace(/\//g, '-');
		const dateParts = splitedDate.split('-');
		if (date.includes('/')) {
		  return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) -1, parseInt(dateParts[0]));
		} else {
		  return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) -1, parseInt(dateParts[2]));
		}
	  }

	calcularAntiguedad(): void {
		if (this.examen.fechaAltaEmpleado) {
			this.seniority = moment().diff(
				moment(this.examen.fechaAltaEmpleado),
				'years'
			);
			if (this.seniority > 1) {
				this.unidadTiempo = 'años';
			} else if (this.seniority < 1) {
				this.seniority = moment().diff(
					moment(this.examen.fechaAltaEmpleado),
					'months'
				);
				if (this.seniority > 1) {
					this.unidadTiempo = 'meses';
				} else {
					this.unidadTiempo = 'mes';
				}
			} else {
				this.unidadTiempo = 'año';
			}
		}
	}

	async getTiposDictamen(): Promise<void> {
		const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
		this.tiposDictamen = dataFromOffline.filter(
			(x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
		);
	}

	async getEspecialidades(): Promise<void> {
		const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
		this.especialidades = especialidadesListFromOffline;
	}

	goBack(ruta?): void {
		if (this.examForm.dirty) {
			this.confirm(ruta);
		} else {
			this.returnToExams(ruta);
		}
	}

	confirm(ruta?): void {
		this.confirmationService.confirm({
			header: `¿Está seguro de que desea cancelar la carga del examen?`,
			message: `Si cancela el examen ahora perderá toda la información cargada hasta el momento`,
			key: 'goBackFormEC',
			accept: () => {
				this.asideService.setInsideExamen(false);
				this.returnToExams(ruta);
			},
		});
	}

	returnToExams(ruta?): void {
		this.router.navigate([ruta ? ruta : 'examenes']);
	}

	buildUrlApi(method: string): string {
		return `${environment.apiUrl}` + method;
	}

	print(): void {
		window.print();
	}

	capitalize(word: string): string {
		if (!word) {
			return word;
		}
		return word[0].toUpperCase() + word.substr(1).toLowerCase();
	}

	async onSubmit(): Promise<any> {
		this.submitted = true;
		if (this.examForm.invalid || this.attachedFiles.invalid || this.medicoFirmaB64 == null) {
			this.navigateInvalidField('ng-invalid');
			return;
		}
		this.enviandose = true;
		if (this.isOnline) {
			this.saveToOnline();
		} else {
			this.saveToOffline();
		}
	}

	private navigateInvalidField(classFocus: string): void {
		const invalidFields = [].slice.call(
			document.getElementsByClassName(classFocus)
		);
		const field = invalidFields[1];
		field.scrollIntoViewIfNeeded();
		field.focus();
	}

	private saveToOnline(): void {
		this.groupDTemplateService
			.loadExam(this.buildRequest(), this.configForm.baseUrl)
			.subscribe(
				(response) => {
					this.databaseService.deleteItemFromTable(this.examen.id,
						`examenes${(this.examen.categoriaExamen === 'periodicos'
							? 'Periodicos'
							: 'Reevaluacion')}`);
					this.databaseService.deleteItemFromTable(this.examen.id,
						`examenes${(this.examen.categoriaExamen === 'periodicos'
							? 'PeriodicosFiltrados'
							: 'ReevaluacionFiltrados')}`);
					this.messageAlertServices.setMessage(0, {
						severity: 'success',
						summary: '',
						detail: response.message,
						key: 'examen',
					});
					setTimeout(() => {
						this.returnToExams();
					}, 500);
					this.enviandose = false;
				},
				(error) => {
					this.formatResponseAndOpenError(error);
				}
			);
	}

	private saveToOffline(): void {
		const dataToSend = this.buildRequest();
		dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
		dataToSend.cargadoOffline = true;
		const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';

		this.databaseService
			.setExameneOnExamenesPorEnviarTable(
				this.examen,
				dataToSend,
				false,
				this.examen.categoriaExamen === 'periodicos'
					? 'Periodicos'
					: 'Reevaluacion',
				this.buildUrlApi(this.configForm.baseUrl)
			)
			.then((response) => {
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'Periodicos'
						: 'Reevaluacion')}`);
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'PeriodicosFiltrados'
						: 'ReevaluacionFiltrados')}`);
				this.backgroundSyncService.registerEvent('save-examen');
				this.messageAlertServices.setMessage(0, {
					severity: 'success',
					summary: '',
					detail: details,
					key: 'examen',
				});
				setTimeout(() => {
					this.returnToExams();
				}, 500);
			})
			.catch((e) => {
				this.messageAlertServices.setMessage(0, {
					severity: 'error',
					summary: '',
					detail:
						'Ha ocurrido un error. Por favor reinitente más tarde y disculpe las molestias ocasionadas',
					key: 'examen',
				});
			});
	}

	buildRequest(): any {
		var examFormData = { ...this.examForm.getRawValue() };
		examFormData.userId = this.currentUser.userId;
		examFormData.modelId = this.currentUser.modelId;
    	examFormData.username = this.currentUser.username;
		examFormData.tipoEstudio = this.configForm.code;
		examFormData.examenNumero = this.examen.id;
		examFormData.fechaRealizacion = moment(examFormData.fechaRealizacion).format('yyyy-MM-DD');
		examFormData.fechaIngresoEmpresa = moment(examFormData.fechaIngresoEmpresa).format('yyyy-MM-DD');
		examFormData.antiguedadPuestoTrabajador = moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD');
		examFormData.fumaDesde = (examFormData.fumaDesde) ?  moment(examFormData.fumaDesde).format('yyyy-MM-DD') : null;
		examFormData.laringitisCronicaDesde = (examFormData.laringitisCronicaDesde) ?  moment(examFormData.laringitisCronicaDesde).format('yyyy-MM-DD') : null;
		examFormData.disfoniaDesde = (examFormData.disfoniaDesde) ?  moment(examFormData.disfoniaDesde).format('yyyy-MM-DD') : null;
		examFormData.esEdicion = !!(this.examen?.modoVista === "edit" && this.isOnline) || null;
		examFormData.adjuntos = this.attachedFiles.data;
		examFormData.medicoFirmaB64 = this.medicoFirmaB64;
      	examFormData.medicoFirmaSigString = this.medicoFirmaSigString;
	
		examFormData = this.evaluateChangeTrabajador(examFormData);

		return examFormData;
	}
  
	private evaluateChangeTrabajador(object) {
		if (this.examen.seModificoTrabajador 
			|| this.examen.trabajador.fechaNacimiento != moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			|| this.examen.trabajador.apellidoNombre != this.examForm.controls.apellidoNombre.value) {

			object.trabajador = {
				apellidoNombre: this.examForm.controls.apellidoNombre.value,
				fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			};
			this.examen.seModificoTrabajador = true;
		}
		return object;
	}

	formatResponseAndOpenError(error) {
		let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.openErrorAlert(message, 'examen');
	}

	private openErrorAlert(message: string, key: string): void {
		this.messageAlertServices.setMessage(0, {
			severity: 'error',
			summary: '',
			detail: message,
			key: key,
		});
		setTimeout(() => {
			const header = document.querySelector('#templateContainer') as any;
			window.scroll(0, header.offsetTop - 150);
		}, 100);
		this.enviandose = false;
	}

	/**
	 * función que recibe el trigger desde el componente attach-upload-file
	 * con el objeto actualizado de la lista de archivos y errores
	 * @param  {object} event
	 * @example:
	 *  {
	 *    errors: {
	 *      isSizeValid: false
	 *      isTypeValid: false,
	 *    },
	 *    data: [
	 *       {
	 *        archivoBase64: todounstringpegado,
	 *        nombreOriginal: "example.png",
	 *        tipo: "png",
	 *        size: 121354,
	 *        esAlta:false,
	 *        esBaja:false
	 *    ],
	 *    invalid: false,
	 *    isEmpty: true,
	 *    attachedFilesValidQuantity: 0
	 *  }
	 */
	getAttachedFiles(event: any): any {
		const { errors } = event;

		this.attachedFiles = event;
		if (errors.isSizeValid && errors.isTypeValid) {
			// asigno la data al objeto para enviar
			return false;
		}
	}

	/**
	 * @description:
	 * * Asignacion de valores a los campos en modo edicion
	 */
	private setValuesOnFormOnVerOrEditMode(): void {
		this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);
		this.examen.codigoDictamen = this.examen.tipoDictamen ? this.examen.tipoDictamen : this.examen.codigoDictamen;
		this.examForm.controls.codigoDictamen.setValue(this.examen.codigoDictamen);
		this.examForm.controls.medicoNombre.setValue(this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));
		this.examForm.controls.medicoMatricula.setValue(this.examen.medicoMatricula);
		this.examForm.controls.medicoEspecialidad.setValue(this.examen.medicoEspecialidad);
		(this.examen?.antiguedadOtrosCargos) ? this.examForm.controls.antiguedadOtrosCargos.setValue(this.examen?.antiguedadOtrosCargos) : null;
		(this.examen?.antiguedadDescripcion) ? this.examForm.controls.antiguedadDescripcion.setValue(this.examen?.antiguedadDescripcion) : null;
		(this.examen?.docente) ? this.examForm.controls.docente.setValue(this.examen?.docente) : null;
		(this.examen?.titular) ? this.examForm.controls.titular.setValue(this.examen?.titular) : null;
		(this.examen?.provisorio) ? this.examForm.controls.provisorio.setValue(this.examen?.provisorio) : null;
		(this.examen?.suplente) ? this.examForm.controls.suplente.setValue(this.examen?.suplente) : null;
		(this.examen?.cargaHorariaDiaria) ? this.examForm.controls.cargaHorariaDiaria.setValue(this.examen?.cargaHorariaDiaria) : null;
		(this.examen?.cargaHorariaSemanal) ? this.examForm.controls.cargaHorariaSemanal.setValue(this.examen?.cargaHorariaSemanal) : null;
		(this.examen?.educacionPrePrimario) ? this.examForm.controls.educacionPrePrimario.setValue(this.examen?.educacionPrePrimario) : null;
		(this.examen?.educacionEnPrimario) ? this.examForm.controls.educacionEnPrimario.setValue(this.examen?.educacionEnPrimario) : null;
		(this.examen?.educacionEnSecundario) ? this.examForm.controls.educacionEnSecundario.setValue(this.examen?.educacionEnSecundario) : null;
		(this.examen?.educacionEnTerciario) ? this.examForm.controls.educacionEnTerciario.setValue(this.examen?.educacionEnTerciario) : null;
		(this.examen?.educacionEnUniversitario) ? this.examForm.controls.educacionEnUniversitario.setValue(this.examen?.educacionEnUniversitario) : null;
		(this.examen?.cargaHorariaOtroEstablecimiento) ? this.examForm.controls.cargaHorariaOtroEstablecimiento.setValue(this.examen?.cargaHorariaOtroEstablecimiento) : null;
		(this.examen?.otroEstablecimientoTitular) ? this.examForm.controls.otroEstablecimientoTitular.setValue(this.examen?.otroEstablecimientoTitular) : null;
		(this.examen?.otroEstablecimientoProvisorio) ? this.examForm.controls.otroEstablecimientoProvisorio.setValue(this.examen?.otroEstablecimientoProvisorio) : null;
		(this.examen?.otroEstablecimientoSuplente) ? this.examForm.controls.otroEstablecimientoSuplente.setValue(this.examen?.otroEstablecimientoSuplente) : null;
		(this.examen?.otroEstabCargaHorariaDiaria) ? this.examForm.controls.otroEstabCargaHorariaDiaria.setValue(this.examen?.otroEstabCargaHorariaDiaria) : null;
		(this.examen?.otroEstabCargaHorariaSemanal) ? this.examForm.controls.otroEstabCargaHorariaSemanal.setValue(this.examen?.otroEstabCargaHorariaSemanal) : null;
		(this.examen?.otroEstabEducacionPrePrimario) ? this.examForm.controls.otroEstabEducacionPrePrimario.setValue(this.examen?.otroEstabEducacionPrePrimario) : null;
		(this.examen?.otroEstabEducacionEnPrimario) ? this.examForm.controls.otroEstabEducacionEnPrimario.setValue(this.examen?.otroEstabEducacionEnPrimario) : null;
		(this.examen?.otroEstabEducacionEnSecundario) ? this.examForm.controls.otroEstabEducacionEnSecundario.setValue(this.examen?.otroEstabEducacionEnSecundario) : null;
		(this.examen?.otroEstabEducacionEnTerciario) ? this.examForm.controls.otroEstabEducacionEnTerciario.setValue(this.examen?.otroEstabEducacionEnTerciario) : null;
		(this.examen?.otroEstabEducacionEnUniversitario) ? this.examForm.controls.otroEstabEducacionEnUniversitario.setValue(this.examen?.otroEstabEducacionEnUniversitario) : null;
		(this.examen?.callCenter) ? this.examForm.controls.callCenter.setValue(this.examen?.callCenter) : null;
		(this.examen?.callCenterCargaHorariaDiaria) ? this.examForm.controls.callCenterCargaHorariaDiaria.setValue(this.examen?.callCenterCargaHorariaDiaria) : null;
		(this.examen?.callCenterCargaHorariaSemanal) ? this.examForm.controls.callCenterCargaHorariaSemanal.setValue(this.examen?.callCenterCargaHorariaSemanal) : null;
		(this.examen?.callCenterDescripcion) ? this.examForm.controls.callCenterDescripcion.setValue(this.examen?.callCenterDescripcion) : null;
		(this.examen?.otro) ? this.examForm.controls.otro.setValue(this.examen?.otro) : null;
		(this.examen?.otroCargaHorariaDiaria) ? this.examForm.controls.otroCargaHorariaDiaria.setValue(this.examen?.otroCargaHorariaDiaria) : null;
		(this.examen?.otroCargaHorariaSemanal) ? this.examForm.controls.otroCargaHorariaSemanal.setValue(this.examen?.otroCargaHorariaSemanal) : null;
		(this.examen?.otroDescripcion) ? this.examForm.controls.otroDescripcion.setValue(this.examen?.otroDescripcion) : null;
		(this.examen?.monoaural) ? this.examForm.controls.monoaural.setValue(this.examen?.monoaural) : null;
		(this.examen?.biaural) ? this.examForm.controls.biaural.setValue(this.examen?.biaural) : null;
		(this.examen?.reguladorVolumen) ? this.examForm.controls.reguladorVolumen.setValue(this.examen?.reguladorVolumen) : null;
		(this.examen?.servicioTelefonicoDescripcion) ? this.examForm.controls.servicioTelefonicoDescripcion.setValue(this.examen?.servicioTelefonicoDescripcion) : null;
		(this.examen?.tomaAlcohol) ? this.examForm.controls.tomaAlcohol.setValue(this.examen?.tomaAlcohol) : null;
		(this.examen?.fuma) ? this.examForm.controls.fuma.setValue(this.examen?.fuma) : null;
		(this.examen?.fumaCantidad) ? this.examForm.controls.fumaCantidad.setValue(this.examen?.fumaCantidad) : null;
		(this.examen?.fumaDesde) ? this.examForm.controls.fumaDesde.setValue(new Date(moment(this.examen?.fumaDesde).format())) : null;
		(this.examen?.tomaMedicacion) ? this.examForm.controls.tomaMedicacion.setValue(this.examen?.tomaMedicacion) : null;
		(this.examen?.tomaMedicacionDetalle) ? this.examForm.controls.tomaMedicacionDetalle.setValue(this.examen?.tomaMedicacionDetalle) : null;
		(this.examen?.realizaOtrasActividadesEsfuerzovoz) ? this.examForm.controls.realizaOtrasActividadesEsfuerzovoz.setValue(this.examen?.realizaOtrasActividadesEsfuerzovoz) : null;
		(this.examen?.habitosDescripcion) ? this.examForm.controls.habitosDescripcion.setValue(this.examen?.habitosDescripcion) : null;
		(this.examen?.respiratorios) ? this.examForm.controls.respiratorios.setValue(this.examen?.respiratorios) : null;
		(this.examen?.respiratoriosDesc) ? this.examForm.controls.respiratoriosDesc.setValue(this.examen?.respiratoriosDesc) : null;
		(this.examen?.alergicos) ? this.examForm.controls.alergicos.setValue(this.examen?.alergicos) : null;
		(this.examen?.alergicosDesc) ? this.examForm.controls.alergicosDesc.setValue(this.examen?.alergicosDesc) : null;
		(this.examen?.quirurgicos) ? this.examForm.controls.quirurgicos.setValue(this.examen?.quirurgicos) : null;
		(this.examen?.quirurgicosDesc) ? this.examForm.controls.quirurgicosDesc.setValue(this.examen?.quirurgicosDesc) : null;
		(this.examen?.digestivos) ? this.examForm.controls.digestivos.setValue(this.examen?.digestivos) : null;
		(this.examen?.digestivosDesc) ? this.examForm.controls.digestivosDesc.setValue(this.examen?.digestivosDesc) : null;
		(this.examen?.herniaHiatal) ? this.examForm.controls.herniaHiatal.setValue(this.examen?.herniaHiatal) : null;
		(this.examen?.herniaHiatalDesc) ? this.examForm.controls.herniaHiatalDesc.setValue(this.examen?.herniaHiatalDesc) : null;
		(this.examen?.reflujoGastroesofagico) ? this.examForm.controls.reflujoGastroesofagico.setValue(this.examen?.reflujoGastroesofagico) : null;
		(this.examen?.reflujoGastroesofagicoDesc) ? this.examForm.controls.reflujoGastroesofagicoDesc.setValue(this.examen?.reflujoGastroesofagicoDesc) : null;
		(this.examen?.tiroideos) ? this.examForm.controls.tiroideos.setValue(this.examen?.tiroideos) : null;
		(this.examen?.tiroideosDesc) ? this.examForm.controls.tiroideosDesc.setValue(this.examen?.tiroideosDesc) : null;
		(this.examen?.laringitisCronica) ? this.examForm.controls.laringitisCronica.setValue(this.examen?.laringitisCronica) : null;
		(this.examen?.laringitisCronicaDesde) ? this.examForm.controls.laringitisCronicaDesde.setValue(new Date(moment(this.examen?.laringitisCronicaDesde).format())) : null;
		(this.examen?.poliposFaringeos) ? this.examForm.controls.poliposFaringeos.setValue(this.examen?.poliposFaringeos) : null;
		(this.examen?.poliposLaringeosDesc) ? this.examForm.controls.poliposLaringeosDesc.setValue(this.examen?.poliposLaringeosDesc) : null;
		(this.examen?.nodulosVocales) ? this.examForm.controls.nodulosVocales.setValue(this.examen?.nodulosVocales) : null;
		(this.examen?.nodulosVocalesDesc) ? this.examForm.controls.nodulosVocalesDesc.setValue(this.examen?.nodulosVocalesDesc) : null;
		(this.examen?.disfonia) ? this.examForm.controls.disfonia.setValue(this.examen?.disfonia) : null;
		(this.examen?.disfoniaDesc) ? this.examForm.controls.disfoniaDesc.setValue(this.examen?.disfoniaDesc) : null;
		(this.examen?.disfoniaDesde) ? this.examForm.controls.disfoniaDesde.setValue(new Date(moment(this.examen?.disfoniaDesde).format())) : null;
		(this.examen?.antecedentesOtras) ? this.examForm.controls.antecedentesOtras.setValue(this.examen?.antecedentesOtras) : null;
		(this.examen?.caractSubjetivasVoz) ? this.examForm.controls.caractSubjetivasVoz.setValue(this.examen?.caractSubjetivasVoz) : null;
		(this.examen?.aspectoAnatomicoLaringe) ? this.examForm.controls.aspectoAnatomicoLaringe.setValue(this.examen?.aspectoAnatomicoLaringe) : null;
		(this.examen?.observaciones) ? this.examForm.controls.observaciones.setValue(this.examen?.observaciones) : null;
		(this.examen?.diagnosticoSugerencias) ? this.examForm.controls.diagnosticoSugerencias.setValue(this.examen?.diagnosticoSugerencias) : null;
		this.clickRadioButtonOtrosCargos();
		this.clickRadioButtonDocente();
		this.clickRadioButtonCargaHorariaOtroEstablecimiento();
		this.clickRadioButtonCallCenter();
		this.clickRadioButtonOtro();
		this.clickRadioButtonAuricularesMonoaural();
		this.clickRadioButtonAuricularesBiaural();
		this.clickRadioButtonFuma();
		this.clickRadioButtonTomaMedicacion();
		this.clickRadioButtonRealizaOtrasActividadesEsfuerzovoz();
		this.clickRadioButtonRespiratorios();
		this.clickRadioButtonAlergicos();
		this.clickRadioButtonQuirurgicos();
		this.clickRadioButtonDigestivos();
		this.clickRadioButtonHerniaHiatal();
		this.clickRadioButtonReflujoGastroesofagico();
		this.clickRadioButtonTiroideos();
		this.clickRadioButtonLaringitisCronica();
		this.clickRadioButtonPolipos();
		this.clickRadioButtonNodulos();
		this.clickRadioButtonDisfonia();
	}

	clickRadioButtonOtrosCargos() {
		if (this.examForm.controls.antiguedadOtrosCargos.value) {
			this.examForm.controls.antiguedadDescripcion.enable();
			this.examForm.controls.antiguedadDescripcion.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.antiguedadDescripcion.setValue('');
			this.examForm.controls.antiguedadDescripcion.disable();
			this.examForm.controls.antiguedadDescripcion.setValidators(null);
		}
		this.examForm.controls.antiguedadDescripcion.updateValueAndValidity();
	}

	clickRadioButtonDocente() {
		if (this.examForm.controls.docente.value) {
			this.examForm.controls.titular.enable();
			this.examForm.controls.suplente.enable();
			this.examForm.controls.provisorio.enable();
			this.examForm.controls.cargaHorariaDiaria.enable();
			this.examForm.controls.cargaHorariaSemanal.enable();
			this.examForm.controls.educacionPrePrimario.enable();
			this.examForm.controls.educacionEnPrimario.enable();
			this.examForm.controls.educacionEnSecundario.enable();
			this.examForm.controls.educacionEnTerciario.enable();
			this.examForm.controls.educacionEnUniversitario.enable();
			this.examForm.controls.cargaHorariaDiaria.setValidators([Validators.required]);
			this.examForm.controls.cargaHorariaSemanal.setValidators([Validators.required]);
		} else {
			this.examForm.controls.titular.disable();
			this.examForm.controls.suplente.disable();
			this.examForm.controls.provisorio.disable();
			this.examForm.controls.cargaHorariaDiaria.disable();
			this.examForm.controls.cargaHorariaSemanal.disable();
			this.examForm.controls.educacionPrePrimario.disable();
			this.examForm.controls.educacionEnPrimario.disable();
			this.examForm.controls.educacionEnSecundario.disable();
			this.examForm.controls.educacionEnTerciario.disable();
			this.examForm.controls.educacionEnUniversitario.disable();
			this.examForm.controls.titular.setValue(false);
			this.examForm.controls.suplente.setValue(false);
			this.examForm.controls.provisorio.setValue(false);
			this.examForm.controls.educacionPrePrimario.setValue(false);
			this.examForm.controls.educacionEnPrimario.setValue(false);
			this.examForm.controls.educacionEnSecundario.setValue(false);
			this.examForm.controls.educacionEnTerciario.setValue(false);
			this.examForm.controls.educacionEnUniversitario.setValue(false);
			this.examForm.controls.cargaHorariaDiaria.setValue(null);
			this.examForm.controls.cargaHorariaSemanal.setValue(null);
			this.examForm.controls.cargaHorariaDiaria.setValidators(null);
			this.examForm.controls.cargaHorariaSemanal.setValidators(null);
		}
		this.examForm.controls.cargaHorariaDiaria.updateValueAndValidity();
		this.examForm.controls.cargaHorariaSemanal.updateValueAndValidity();
	}

	clickRadioButtonCargaHorariaOtroEstablecimiento() {
		if (this.examForm.controls.cargaHorariaOtroEstablecimiento.value) {
			this.examForm.controls.otroEstablecimientoTitular.enable();
			this.examForm.controls.otroEstablecimientoSuplente.enable();
			this.examForm.controls.otroEstablecimientoProvisorio.enable();
			this.examForm.controls.otroEstabEducacionPrePrimario.enable();
			this.examForm.controls.otroEstabEducacionEnPrimario.enable();
			this.examForm.controls.otroEstabEducacionEnSecundario.enable();
			this.examForm.controls.otroEstabEducacionEnTerciario.enable();
			this.examForm.controls.otroEstabEducacionEnUniversitario.enable();
			this.examForm.controls.otroEstabCargaHorariaDiaria.enable();
			this.examForm.controls.otroEstabCargaHorariaSemanal.enable();
			this.examForm.controls.otroEstabCargaHorariaDiaria.setValidators([Validators.required]);
			this.examForm.controls.otroEstabCargaHorariaSemanal.setValidators([Validators.required]);
		} else {
			this.examForm.controls.otroEstablecimientoTitular.disable();
			this.examForm.controls.otroEstablecimientoSuplente.disable();
			this.examForm.controls.otroEstablecimientoProvisorio.disable();
			this.examForm.controls.otroEstabEducacionPrePrimario.disable();
			this.examForm.controls.otroEstabEducacionEnPrimario.disable();
			this.examForm.controls.otroEstabEducacionEnSecundario.disable();
			this.examForm.controls.otroEstabEducacionEnTerciario.disable();
			this.examForm.controls.otroEstabEducacionEnUniversitario.disable();
			this.examForm.controls.otroEstabCargaHorariaDiaria.disable();
			this.examForm.controls.otroEstabCargaHorariaSemanal.disable();
			this.examForm.controls.otroEstablecimientoTitular.setValue(false);
			this.examForm.controls.otroEstablecimientoSuplente.setValue(false);
			this.examForm.controls.otroEstablecimientoProvisorio.setValue(false);
			this.examForm.controls.otroEstabEducacionPrePrimario.setValue(false);
			this.examForm.controls.otroEstabEducacionEnPrimario.setValue(false);
			this.examForm.controls.otroEstabEducacionEnSecundario.setValue(false);
			this.examForm.controls.otroEstabEducacionEnTerciario.setValue(false);
			this.examForm.controls.otroEstabEducacionEnUniversitario.setValue(false);
			this.examForm.controls.otroEstabCargaHorariaDiaria.setValue(null);
			this.examForm.controls.otroEstabCargaHorariaSemanal.setValue(null);
			this.examForm.controls.otroEstabCargaHorariaDiaria.setValidators(null);
			this.examForm.controls.otroEstabCargaHorariaSemanal.setValidators(null);
		}
		this.examForm.controls.otroEstabCargaHorariaDiaria.updateValueAndValidity();
		this.examForm.controls.otroEstabCargaHorariaSemanal.updateValueAndValidity();
	}

	clickRadioButtonCallCenter() {
		if (this.examForm.controls.callCenter.value) {
			this.examForm.controls.callCenterCargaHorariaDiaria.enable();
			this.examForm.controls.callCenterCargaHorariaSemanal.enable();
			this.examForm.controls.callCenterDescripcion.enable();
			this.examForm.controls.callCenterCargaHorariaDiaria.setValidators([Validators.required]);
			this.examForm.controls.callCenterCargaHorariaSemanal.setValidators([Validators.required]);
			this.examForm.controls.callCenterDescripcion.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.callCenterCargaHorariaDiaria.disable();
			this.examForm.controls.callCenterCargaHorariaSemanal.disable();
			this.examForm.controls.callCenterDescripcion.disable();
			this.examForm.controls.callCenterCargaHorariaDiaria.setValidators(null);
			this.examForm.controls.callCenterCargaHorariaSemanal.setValidators(null);
			this.examForm.controls.callCenterDescripcion.setValidators(null);
			this.examForm.controls.callCenterCargaHorariaDiaria.setValue(null);
			this.examForm.controls.callCenterCargaHorariaSemanal.setValue(null);
			this.examForm.controls.callCenterDescripcion.setValue(null);
		}
		this.examForm.controls.callCenterCargaHorariaDiaria.updateValueAndValidity();
		this.examForm.controls.callCenterCargaHorariaSemanal.updateValueAndValidity();
		this.examForm.controls.callCenterDescripcion.updateValueAndValidity();
	}

	clickRadioButtonOtro() {
		if (this.examForm.controls.otro.value) {
			this.examForm.controls.otroCargaHorariaDiaria.enable();
			this.examForm.controls.otroCargaHorariaSemanal.enable();
			this.examForm.controls.otroDescripcion.enable();
			this.examForm.controls.otroCargaHorariaDiaria.setValidators([Validators.required]);
			this.examForm.controls.otroCargaHorariaSemanal.setValidators([Validators.required]);
			this.examForm.controls.otroDescripcion.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.otroCargaHorariaDiaria.disable();
			this.examForm.controls.otroCargaHorariaSemanal.disable();
			this.examForm.controls.otroDescripcion.disable();
			this.examForm.controls.otroCargaHorariaDiaria.setValidators(null);
			this.examForm.controls.otroCargaHorariaSemanal.setValidators(null);
			this.examForm.controls.otroDescripcion.setValidators(null);
			this.examForm.controls.otroCargaHorariaDiaria.setValue(null);
			this.examForm.controls.otroCargaHorariaSemanal.setValue(null);
			this.examForm.controls.otroDescripcion.setValue(null);
		}
		this.examForm.controls.otroCargaHorariaDiaria.updateValueAndValidity();
		this.examForm.controls.otroCargaHorariaSemanal.updateValueAndValidity();
		this.examForm.controls.otroDescripcion.updateValueAndValidity();
	}

	clickRadioButtonAuricularesMonoaural() {
		if (this.examForm.controls.monoaural.value) {
			this.examForm.controls.biaural.setValue(null);
			this.examForm.controls.reguladorVolumen.enable();
			this.examForm.controls.reguladorVolumen.setValidators([Validators.required]);
			this.examForm.controls.reguladorVolumen.updateValueAndValidity();
		}
	}

	clickRadioButtonAuricularesBiaural() {
		if (this.examForm.controls.biaural.value) {
			this.examForm.controls.monoaural.setValue(null);
			this.examForm.controls.reguladorVolumen.enable();
			this.examForm.controls.reguladorVolumen.setValidators([Validators.required]);
			this.examForm.controls.reguladorVolumen.updateValueAndValidity();
		}
	}

	clickRadioButtonFuma() {
		if (this.examForm.controls.fuma.value) {
			this.examForm.controls.fumaCantidad.enable();
			this.examForm.controls.fumaDesde.enable();
			this.examForm.controls.fumaCantidad.setValidators([Validators.required]);
			this.examForm.controls.fumaDesde.setValidators([Validators.required]);
		} else {
			this.examForm.controls.fumaCantidad.disable();
			this.examForm.controls.fumaDesde.disable();
			this.examForm.controls.fumaCantidad.setValidators(null);
			this.examForm.controls.fumaDesde.setValidators(null);
			this.examForm.controls.fumaCantidad.setValue(null);
			this.examForm.controls.fumaDesde.setValue(null);
		}
		this.examForm.controls.fumaCantidad.updateValueAndValidity();
		this.examForm.controls.fumaDesde.updateValueAndValidity();
	}

	clickRadioButtonTomaMedicacion() {
		if (this.examForm.controls.tomaMedicacion.value) {
			this.examForm.controls.tomaMedicacionDetalle.enable();
			this.examForm.controls.tomaMedicacionDetalle.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.tomaMedicacionDetalle.disable();
			this.examForm.controls.tomaMedicacionDetalle.setValidators(null);
			this.examForm.controls.tomaMedicacionDetalle.setValue(null);
		}
		this.examForm.controls.tomaMedicacionDetalle.updateValueAndValidity();
	}

	clickRadioButtonRealizaOtrasActividadesEsfuerzovoz() {
		if (this.examForm.controls.realizaOtrasActividadesEsfuerzovoz.value) {
			this.examForm.controls.habitosDescripcion.enable();
			this.examForm.controls.habitosDescripcion.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.habitosDescripcion.disable();
			this.examForm.controls.habitosDescripcion.setValidators(null);
			this.examForm.controls.habitosDescripcion.setValue(null);
		}
		this.examForm.controls.habitosDescripcion.updateValueAndValidity();
	}

	clickRadioButtonRespiratorios() {
		if (this.examForm.controls.respiratorios.value) {
			this.examForm.controls.respiratoriosDesc.enable();
			this.examForm.controls.respiratoriosDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.respiratoriosDesc.disable();
			this.examForm.controls.respiratoriosDesc.setValidators(null);
			this.examForm.controls.respiratoriosDesc.setValue(null);
		}
		this.examForm.controls.respiratoriosDesc.updateValueAndValidity();
	}

	clickRadioButtonAlergicos() {
		if (this.examForm.controls.alergicos.value) {
			this.examForm.controls.alergicosDesc.enable();
			this.examForm.controls.alergicosDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.alergicosDesc.disable();
			this.examForm.controls.alergicosDesc.setValidators(null);
			this.examForm.controls.alergicosDesc.setValue(null);
		}
		this.examForm.controls.alergicosDesc.updateValueAndValidity();
	}

	clickRadioButtonQuirurgicos() {
		if (this.examForm.controls.quirurgicos.value) {
			this.examForm.controls.quirurgicosDesc.enable();
			this.examForm.controls.quirurgicosDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.quirurgicosDesc.disable();
			this.examForm.controls.quirurgicosDesc.setValidators(null);
			this.examForm.controls.quirurgicosDesc.setValue(null);
		}
		this.examForm.controls.quirurgicosDesc.updateValueAndValidity();
	}

	clickRadioButtonDigestivos() {
		if (this.examForm.controls.digestivos.value) {
			this.examForm.controls.digestivosDesc.enable();
			this.examForm.controls.digestivosDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.digestivosDesc.disable();
			this.examForm.controls.digestivosDesc.setValidators(null);
			this.examForm.controls.digestivosDesc.setValue(null);
		}
		this.examForm.controls.digestivosDesc.updateValueAndValidity();
	}

	clickRadioButtonHerniaHiatal() {
		if (this.examForm.controls.herniaHiatal.value) {
			this.examForm.controls.herniaHiatalDesc.enable();
			this.examForm.controls.herniaHiatalDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.herniaHiatalDesc.disable();
			this.examForm.controls.herniaHiatalDesc.setValidators(null);
			this.examForm.controls.herniaHiatalDesc.setValue(null);
		}
		this.examForm.controls.herniaHiatalDesc.updateValueAndValidity();
	}

	clickRadioButtonReflujoGastroesofagico() {
		if (this.examForm.controls.reflujoGastroesofagico.value) {
			this.examForm.controls.reflujoGastroesofagicoDesc.enable();
			this.examForm.controls.reflujoGastroesofagicoDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.reflujoGastroesofagicoDesc.disable();
			this.examForm.controls.reflujoGastroesofagicoDesc.setValidators(null);
			this.examForm.controls.reflujoGastroesofagicoDesc.setValue(null);
		}
		this.examForm.controls.reflujoGastroesofagicoDesc.updateValueAndValidity();
	}

	clickRadioButtonTiroideos() {
		if (this.examForm.controls.tiroideos.value) {
			this.examForm.controls.tiroideosDesc.enable();
			this.examForm.controls.tiroideosDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.tiroideosDesc.disable();
			this.examForm.controls.tiroideosDesc.setValidators(null);
			this.examForm.controls.tiroideosDesc.setValue(null);
		}
		this.examForm.controls.tiroideosDesc.updateValueAndValidity();
	}

	clickRadioButtonLaringitisCronica() {
		if (this.examForm.controls.laringitisCronica.value) {
			this.examForm.controls.laringitisCronicaDesde.enable();
			this.examForm.controls.laringitisCronicaDesde.setValidators([Validators.required]);
		} else {
			this.examForm.controls.laringitisCronicaDesde.disable();
			this.examForm.controls.laringitisCronicaDesde.setValidators(null);
			this.examForm.controls.laringitisCronicaDesde.setValue(null);
		}
		this.examForm.controls.laringitisCronicaDesde.updateValueAndValidity();
	}

	clickRadioButtonPolipos() {
		if (this.examForm.controls.poliposFaringeos.value) {
			this.examForm.controls.poliposLaringeosDesc.enable();
			this.examForm.controls.poliposLaringeosDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.poliposLaringeosDesc.disable();
			this.examForm.controls.poliposLaringeosDesc.setValidators(null);
			this.examForm.controls.poliposLaringeosDesc.setValue(null);
		}
		this.examForm.controls.poliposLaringeosDesc.updateValueAndValidity();
	}

	clickRadioButtonNodulos() {
		if (this.examForm.controls.nodulosVocales.value) {
			this.examForm.controls.nodulosVocalesDesc.enable();
			this.examForm.controls.nodulosVocalesDesc.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.nodulosVocalesDesc.disable();
			this.examForm.controls.nodulosVocalesDesc.setValidators(null);
			this.examForm.controls.nodulosVocalesDesc.setValue(null);
		}
		this.examForm.controls.nodulosVocalesDesc.updateValueAndValidity();
	}

	clickRadioButtonDisfonia() {
		if (this.examForm.controls.disfonia.value) {
			this.examForm.controls.disfoniaDesc.enable();
			this.examForm.controls.disfoniaDesde.enable();
			this.examForm.controls.disfoniaDesc.setValidators([Validators.required, Validators.maxLength(250)]);
			this.examForm.controls.disfoniaDesde.setValidators([Validators.required]);
			this.examForm.controls.aspectoAnatomicoLaringe.enable();
			this.examForm.controls.observaciones.enable();
			this.examForm.controls.diagnosticoSugerencias.enable();
			this.examForm.controls.aspectoAnatomicoLaringe.setValidators([Validators.required, Validators.maxLength(250)]);
			this.examForm.controls.observaciones.setValidators([Validators.required, Validators.maxLength(250)]);
			this.examForm.controls.diagnosticoSugerencias.setValidators([Validators.required, Validators.maxLength(250)]);
		} else {
			this.examForm.controls.disfoniaDesc.disable();
			this.examForm.controls.disfoniaDesde.disable();
			this.examForm.controls.disfoniaDesc.setValidators(null);
			this.examForm.controls.disfoniaDesde.setValidators(null);
			this.examForm.controls.disfoniaDesc.setValue(null);
			this.examForm.controls.disfoniaDesde.setValue(null);
			this.examForm.controls.aspectoAnatomicoLaringe.disable();
			this.examForm.controls.observaciones.disable();
			this.examForm.controls.diagnosticoSugerencias.disable();
			this.examForm.controls.aspectoAnatomicoLaringe.setValidators(null);
			this.examForm.controls.observaciones.setValidators(null);
			this.examForm.controls.diagnosticoSugerencias.setValidators(null);
			this.examForm.controls.aspectoAnatomicoLaringe.setValue(null);
			this.examForm.controls.observaciones.setValue(null);
			this.examForm.controls.diagnosticoSugerencias.setValue(null);
		}
		this.examForm.controls.disfoniaDesc.updateValueAndValidity();
		this.examForm.controls.disfoniaDesde.updateValueAndValidity();
		this.examForm.controls.aspectoAnatomicoLaringe.updateValueAndValidity();
		this.examForm.controls.observaciones.updateValueAndValidity();
		this.examForm.controls.diagnosticoSugerencias.updateValueAndValidity();
	}

	clicPuestoDocente($event, valor) {
		switch (valor) {
			case 'titular':
				this.examForm.controls.titular.setValue($event.checked);
				this.examForm.controls.provisorio.setValue(false);
				this.examForm.controls.suplente.setValue(false);
				break;
			case 'provisorio':
				this.examForm.controls.titular.setValue(false);
				this.examForm.controls.provisorio.setValue($event.checked);
				this.examForm.controls.suplente.setValue(false);
				break;
			case 'suplente':
				this.examForm.controls.titular.setValue(false);
				this.examForm.controls.provisorio.setValue(false);
				this.examForm.controls.suplente.setValue($event.checked);
				break;
		}
	}

	clicNivelEducativoDocente($event, valor) {
		switch (valor) {
			case 'educacionPrePrimario':
				this.examForm.controls.educacionPrePrimario.setValue($event.checked);
				this.examForm.controls.educacionEnPrimario.setValue(false);
				this.examForm.controls.educacionEnSecundario.setValue(false);
				this.examForm.controls.educacionEnTerciario.setValue(false);
				this.examForm.controls.educacionEnUniversitario.setValue(false);
				break;
			case 'educacionEnPrimario':
				this.examForm.controls.educacionPrePrimario.setValue(false);
				this.examForm.controls.educacionEnPrimario.setValue($event.checked);
				this.examForm.controls.educacionEnSecundario.setValue(false);
				this.examForm.controls.educacionEnTerciario.setValue(false);
				this.examForm.controls.educacionEnUniversitario.setValue(false);
				break;
			case 'educacionEnSecundario':
				this.examForm.controls.educacionPrePrimario.setValue(false);
				this.examForm.controls.educacionEnPrimario.setValue(false);
				this.examForm.controls.educacionEnSecundario.setValue($event.checked);
				this.examForm.controls.educacionEnTerciario.setValue(false);
				this.examForm.controls.educacionEnUniversitario.setValue(false);
				break;
			case 'educacionEnTerciario':
				this.examForm.controls.educacionPrePrimario.setValue(false);
				this.examForm.controls.educacionEnPrimario.setValue(false);
				this.examForm.controls.educacionEnSecundario.setValue(false);
				this.examForm.controls.educacionEnTerciario.setValue($event.checked);
				this.examForm.controls.educacionEnUniversitario.setValue(false);
				break;
			case 'educacionEnUniversitario':
				this.examForm.controls.educacionPrePrimario.setValue(false);
				this.examForm.controls.educacionEnPrimario.setValue(false);
				this.examForm.controls.educacionEnSecundario.setValue(false);
				this.examForm.controls.educacionEnTerciario.setValue(false);
				this.examForm.controls.educacionEnUniversitario.setValue($event.checked);
				break;
		}
	}

	clicPuestoOtro($event, valor) {
		switch (valor) {
			case 'otroEstablecimientoTitular':
				this.examForm.controls.otroEstablecimientoTitular.setValue($event.checked);
				this.examForm.controls.otroEstablecimientoProvisorio.setValue(false);
				this.examForm.controls.otroEstablecimientoSuplente.setValue(false);
				break;
			case 'otroEstablecimientoProvisorio':
				this.examForm.controls.otroEstablecimientoTitular.setValue(false);
				this.examForm.controls.otroEstablecimientoProvisorio.setValue($event.checked);
				this.examForm.controls.otroEstablecimientoSuplente.setValue(false);
				break;
			case 'otroEstablecimientoSuplente':
				this.examForm.controls.otroEstablecimientoTitular.setValue(false);
				this.examForm.controls.otroEstablecimientoProvisorio.setValue(false);
				this.examForm.controls.otroEstablecimientoSuplente.setValue($event.checked);
				break;
		}
	}

	clicNivelEducativoOtro($event, valor) {
		switch(valor) {
			case 'otroEstabEducacionPrePrimario':
				this.examForm.controls.otroEstabEducacionPrePrimario.setValue($event.checked);
				this.examForm.controls.otroEstabEducacionEnPrimario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnSecundario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnTerciario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnUniversitario.setValue(false);
				break;
			case 'otroEstabEducacionEnPrimario':
				this.examForm.controls.otroEstabEducacionPrePrimario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnPrimario.setValue($event.checked);
				this.examForm.controls.otroEstabEducacionEnSecundario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnTerciario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnUniversitario.setValue(false);
				break;
			case 'otroEstabEducacionEnSecundario':
				this.examForm.controls.otroEstabEducacionPrePrimario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnPrimario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnSecundario.setValue($event.checked);
				this.examForm.controls.otroEstabEducacionEnTerciario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnUniversitario.setValue(false);
				break;
			case 'otroEstabEducacionEnTerciario':
				this.examForm.controls.otroEstabEducacionPrePrimario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnPrimario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnSecundario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnTerciario.setValue($event.checked);
				this.examForm.controls.otroEstabEducacionEnUniversitario.setValue(false);
				break;
			case 'otroEstabEducacionEnUniversitario':
				this.examForm.controls.otroEstabEducacionPrePrimario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnPrimario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnSecundario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnTerciario.setValue(false);
				this.examForm.controls.otroEstabEducacionEnUniversitario.setValue($event.checked);
				break;
		}
	}

	showModalFirma(){
		this.displayModalFirma = true;
	}

	closeModalFirma(){
		this.displayModalFirma = false;
	}

	recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
		this.medicoFirmaB64 = datos.firmaB64;
		this.medicoFirmaSigString = datos.firmaSigString;
	}

	deshabilitarApellidoNombreTrabajador() {
		return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
	}
}
